$(document).ready(function () {

    var params;

    //Set a default rate for slider
    var pass = 70;
    var refer = 80;
    var friction = 90;

    var multirange = document.getElementById('my-slider');

    var calcReset = $(".calc-reset");

    //set a default currency
    var currency = "pound";

    //get a currency from data attr
    currency = $("#m-fraud-calculator").attr("data-currency");
    $("#" + currency).prop("checked", true);

    //set variables based on parameters
    var pcustomers = getUrlParameter('customers');
    var pdirectloss = getUrlParameter('directloss'); 
    var pvendorcost = getUrlParameter('vendorcost'); 
    var ppass = getUrlParameter('pass'); 
    var prefer = getUrlParameter('refer'); 
    var pfriction = getUrlParameter('friction'); 
    var pfail = getUrlParameter('fail'); 
    var pinvestigation = getUrlParameter('investigation');
    var pdropoff = getUrlParameter('dropoff');
    var pcurrency = getUrlParameter('currency');



    //If there are parameters update the values
    if (pcustomers != undefined) {
        console.log("customers");
        $(".calc-customers").val(pcustomers);
        params = true;
    } 

    if (pdirectloss != undefined) {
        $(".calc-direct-loss").val(pdirectloss);
        params = true;
    }

    if (pvendorcost != undefined) {
        $(".calc-direct-cost").val(pvendorcost);
        params = true;
    }

    if (pcurrency != undefined) {
        $("#"+pcurrency).prop("checked", true);
        currency = pcurrency;
        params = true;
    }

    if (params == true) {

        //remove the cookie consent banner
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + 1);
        document.cookie = 'OptanonAlertBoxClosed=' + exdate + '; expires=' + exdate.toUTCString() + '; path=/';
        

        $(".navbar").css("position", "relative");
        $(".navbar").removeClass("headroom");
        $(".navbar").addClass("navbar-fill");
        //console.log("it matches a param");

        if ($("div").not(".m-fraud-calculator")) {
            $(this).hide();
        }
        else{
            console.log("something else");
        }
        

        $(".show-export").show();
        $(".top-bar").hide();
        $("div#onetrust-consent-sdk").hide();
        $(".mobile-icons").css({"opacity":"0", "height":"0"});
        $(".m-navigation").hide();
        $(".js-search-trigger").hide();
        $("#my-slider").hide();
        $(".btn-results").hide();
        $(".btn-speak").hide();
        $(".o-wrapper").hide();
        $(".copyright").hide();
        $("footer").css({ "padding": "2rem 0" });
        $("footer .row div").not(":first-child").hide();
        $(".m-banner").removeClass("force_lightgrey");




        //$(".btn-speak").html("<a href=\"https://gbgplc.com\"><button type=\"button\" class=\"btn btn-primary btn-block btn-speak\" data-html2canvas-ignore=\"true\">Speak to a fraud expert</button></a>");
    }



    $(".currency").html("&" + currency + ";");

    $('input[type=radio][name=currency]').change(function () {
        //console.log(this.value);
        currency = this.value;

        $(".currency").html("&"+currency+";");
    });

    //$('input[name="currency"]:checked').val();

    //Do the calculations for the slider and set the variables to the values
    if (ppass != undefined) {
        pass = parseInt(ppass);
    }

    if (ppass != undefined && prefer != undefined) {
        refer = parseInt(ppass) + parseInt(prefer);
    }
    if (ppass != undefined && prefer != undefined && pfriction != undefined) {
        friction = parseInt(ppass) + parseInt(prefer) + parseInt(pfriction);
    
    }

    if (pinvestigation != undefined) {
        $(".calc-investigation").val(pinvestigation);
    }

    if (pdropoff != undefined) {
        $(".calc-dropoff").val(pdropoff);
    }

    $('[data-toggle="tooltip"]').tooltip();

    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };




    //set up the slider
    noUiSlider.create(multirange, {
        start: [pass, refer, friction],
        connect: [true, true, true, true],
        tooltips: [false, false, false],
        step: 1,
        range: {
            'min': [0],
            'max': [100]
        }
    });

    //get array of connect elements
    var connect = multirange.querySelectorAll('.noUi-connect');

    var classes = ['pass', 'refer', 'friction', 'fail'];
    //Add a second set of classes if needed
    //var classesSecondary = ['passed', 'refered', 'frictioned', 'failed'];

    for (var i = 0; i < connect.length; i++) {
        connect[i].classList.add(classes[i]);
        //connect[i].classList.add(classesSecondary[i]);
    }

    multirange.noUiSlider.on('update', function () {
        var valuesarr = multirange.noUiSlider.get(),
            max = multirange.noUiSlider.options.range.max[0],
            oldsum = multirange.noUiSlider.options.range.min[0];// = slider min, will be usually 0

        for (var i = 0; i < connect.length; i++) {
            if (valuesarr[i]) $(connect[i]).text(valuesarr[i] - oldsum + '%');
            else $(connect[i]).text(max - oldsum + '%');
            oldsum = valuesarr[i];
        }


        runCalculator();
    });


    $(window).resize(function () {
        if ($(calcReset).hasClass("active")) {
            //console.log("reset is active");

            if ($(window).width() <= 766) {
                $(".calc-reset-primary").fadeOut();
                $(".calc-reset-secondary").fadeIn();
            }
            else {
                $(".calc-reset-secondary").fadeOut();
                $(".calc-reset-primary").fadeIn();
            }

        }


    });


    multirange.noUiSlider.on('slide', function () {
        if ($(window).width() <= 766) {
            $(".calc-reset-secondary").fadeIn();
            $(".calc-reset-secondary").addClass("active");
        }
        else {
            $(".calc-reset-primary").fadeIn();
        }


    });

    $(".calc-reset").on("click", function () {
        //alert("Resetting the calculator");
        multirange.noUiSlider.set([70, 80, 90]);
        $(".calc-reset").fadeOut();
        $(".calc-reset").removeClass("active");
    });



    //Run the calculator on load
    runCalculator();

    //common class if one of the input fields changes
    $(".calc").change(function () {
        //if ($.isNumeric(calcCustomers)) {
        runCalculator();
        //}
    });

});

//Not needed if we are using select pdf
function generatePDF() {

    // Choose the element that our invoice is rendered in.
    const calc = document.getElementById("m-fraud-calculator");

    var opt = {
        margin: [1, 0, 1, 0],
        filename: 'GBG-Cost-of-fraud.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { windowWidth: 800 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };



    // Choose the element and save the PDF for our user.
    html2pdf()
        .set(opt)
        .from(calc)
        .save();


}

//Function to run the fraud calculator
function runCalculator() {

    //get the values from the slider
    var pass = $(".pass").text();
    var refer = $(".refer").text();
    var friction = $(".friction").text();
    var fail = $(".fail").text();


    pass = parseInt(pass);
    refer = parseInt(refer);
    friction = parseInt(friction);
    fail = parseInt(fail);


    var calcInvestigationDecision = $(".calc-investigation-decision");
    var calcInvestigationDecisionFe = $(".calc-investigation-decision-fe");
    calcInvestigationDecisionFe.val(refer + "%");
    $(".referTag").html("Refer:<span>" + refer + "%</span>");
    $(".calc-refer").attr("value",refer);
    //Add float to number if less than 10
    if (refer >= 10) {
        calcInvestigationDecision.val("0." + refer)
    }
    else {
        calcInvestigationDecision.val("0.0" + refer)
    }


    calcDropoffRate = $(".calc-dropoff-rate");
    calcDropoffRateFe = $(".calc-dropoff-rate-fe");
    calcDropoffRateFe.val(friction + "%");
    $(".frictionTag").html("Friction:<span>" + friction + "%</span>");
    $(".calc-friction").attr("value", friction);
    if (friction >= 10) {
        calcDropoffRate.val("0." + friction)
    }
    else {
        calcDropoffRate.val("0.0" + friction)
    }




    var calcFailedIdentityDescision = $(".calc-failed-identity-descision");
    var calcFailedIdentityDescisionFe = $(".calc-failed-identity-descision-fe");


    calcFailedIdentityDescisionFe.val(fail + "%")
    $(".failTag").html("Fail:<span>" + fail + "%</span>");
    $(".calc-fail").attr("value", fail);
    if (fail >= 10) {
        calcFailedIdentityDescision.val("0." + fail)
    }
    else {
        calcFailedIdentityDescision.val("0.0" + fail)
    }

    var calcTotalRate = $(".calc-total-rate");
    var calcTotalRateFe = $(".calc-total-rate-fe");
    calcTotalRateFe.val(pass + "%");
    $(".passTag").html("Pass:<span>" + pass + "%</span>");
    $(".calc-pass").attr("value", pass);
    if (pass >= 10) {
        calcTotalRate.val("0." + pass)
    }
    else {
        calcTotalRate.val("0.0" + pass)
    }

    var calcTotalRateCalculation = "0." + pass;

    //console.log(pass);
    //console.log(fail);
    //console.log(friction);
    //console.log(fail);



    var calcCustomers = $(".calc-customers").val();

    var calcFailedIdentity = $(".calc-failed-identity").val();

    calcFailedIdentityDescision = $(".calc-failed-identity-descision").val();



    var calcFailedIdentityLoss = $(".calc-failed-identity-loss");

    var calcInvestigation = $(".calc-investigation").val();

    calcInvestigationDecision = $(".calc-investigation-decision").val();

    var calcInvestigationLoss = $(".calc-investigation-loss");

    var calcDropoff = $(".calc-dropoff").val();

    calcDropoffRate = $(".calc-dropoff-rate").val();

    //copy the value across
    $(".calc-failed-identity").attr("value",calcDropoff)

    var calcDropoffLoss = $(".calc-dropoff-loss");

    var calcDirectLoss = $(".calc-direct-loss").val();

    var calcDirectCost = $(".calc-direct-cost").val();





    //Set to false before calculation criteria is met
    var calculate = false;

    //Check is the user inputs valid and set variable if met
    if (($.isNumeric(digitSeperator(calcCustomers)) || calcCustomers.length === 0) && ($.isNumeric(digitSeperator(calcFailedIdentity)) || calcFailedIdentity.length === 0) && ($.isNumeric(digitSeperator(calcInvestigation)) || calcInvestigation.length === 0) && ($.isNumeric(digitSeperator(calcDirectLoss)) || calcDirectLoss.length === 0) && ($.isNumeric(digitSeperator(calcDirectCost)) || calcDirectCost.length === 0)) {
        //console.log("criteria met to run calculation");
        //console.log(digitSeperator(calcCustomers));
        calculate = true;
    }
    else {
        //console.log("criteria not met to calculate");
    }

    //If criteria is met run the calculation
    if (calculate === true) {

        //Covert the inputs to be numeric
        calcDirectLoss = digitSeperator(calcDirectLoss);
        calcDropoff = digitSeperator(calcDropoff);
        calcInvestigation = digitSeperator(calcInvestigation);
        calcCustomers = digitSeperator(calcCustomers);
        calcFailedIdentity = digitSeperator(calcFailedIdentity);
        calcDirectCost = digitSeperator(calcDirectCost);


        //Calculation
        var calcFailedIdentityLossCalculation = (calcCustomers * calcFailedIdentity) * calcFailedIdentityDescision;
        //Calculation
        var calcInvestigationLossCalculation = (calcCustomers * calcInvestigation) * calcInvestigationDecision;
        //Calculation
        var calcDropoffLossCalculation = (calcCustomers * calcDropoff) * calcDropoffRate;


        //Results
        //var calcTotalRate = $(".calc-total-rate");
        //Calculation
        //var calcTotalRateCalculation = (1 - calcFailedIdentityDescision - calcInvestigationDecision - calcDropoffRate).toFixed(2);

        var calcTotalEarning = $(".calc-total-earning");
        //Calculation
        var calcTotalEarningCalculation = calcCustomers * calcFailedIdentity * calcTotalRateCalculation;

        var calcTotalCost = $(".calc-total-cost-figure");
        //Calculation
        var calcTotalCostCalculation = (calcFailedIdentityLossCalculation + calcInvestigationLossCalculation + calcDropoffLossCalculation + calcDirectLoss + calcDirectCost);

        var calcTotalOnboarding = $(".calc-total-onboarding");
        //Calculation
        var calcTotalOnboardingCalculation = (calcTotalEarningCalculation + calcTotalCostCalculation);


        calcFailedIdentityLoss.val(formatNumber(calcFailedIdentityLossCalculation));
        calcInvestigationLoss.val(formatNumber(calcInvestigationLossCalculation));
        calcDropoffLoss.val(formatNumber(calcDropoffLossCalculation));

        calcTotalRate.val(calcTotalRateCalculation);
        calcTotalEarning.val(formatNumber(calcTotalEarningCalculation));
        calcTotalOnboarding.val(formatNumber(calcTotalOnboardingCalculation));
        //calcTotalCost.val(formatNumber(calcTotalCostCalculation));
        calcTotalCost.html(formatNumber(calcTotalCostCalculation));

        if (formatNumber(calcTotalCostCalculation).length > 10) {
            //console.log("There are more than 10 in the calculation");
        }
        else {
            //console.log("There is less than 10");
        }

        //console.log("Failed identity loss: " + calcFailedIdentityLossCalculation);
        //console.log("Investigation loss: " + calcInvestigationLossCalculation);
        //console.log("Dropoff loss: " + calcDropoffLossCalculation);


        //console.log("Total pass rate: " + calcTotalRateCalculation);
        //console.log("Total earning: " + calcTotalEarningCalculation);
        //console.log("Total onboarding: " + calcTotalOnboardingCalculation);
        //console.log("Total cost of fraud: " + formatNumber(calcTotalCostCalculation));


    }

};

function formatNumber(num) {
    return parseFloat(num).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

//Check if there is a decimal seperator and convert
function digitSeperator(figure) {
    if (figure.indexOf(',') > -1) {
        if (figure.indexOf(',') == figure.length - 2 || figure.indexOf(',') == figure.length - 3) {
            //take as decimal
            figure = parseFloat(figure.replace(',', '.')).toFixed(0);
        } else {
            figure = Number(figure.replace(/,/g, ''));
        }
    }

    return figure;

}


//Dont think this is being used anymore
//// Read a page's GET URL variables and return them as an associative array.
//function getUrlVars() {
//    var vars = [], hash;
//    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
//    for (var i = 0; i < hashes.length; i++) {
//        hash = hashes[i].split('=');
//        vars.push(hash[0]);
//        vars[hash[0]] = hash[1];
//    }
//    return vars;
//}